import React from 'react';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import './ServiceComparison.scss';

const ServiceComparison: React.FC = () => {
  return (
    <section id="service-comparison" className="service-comparison">
      <div className="container">
        <div className="comparison-header">
          <h2 className="comparison-title">
            <span className="highlight-text">SERVICE</span> COMPARISON
          </h2>
          <p className="comparison-subtitle">
            Compare our services to find the perfect grooming package for your pet's needs.
          </p>
        </div>
        
        <div className="comparison-table">
          <table>
            <thead>
              <tr>
                <th>Services Included</th>
                <th>5-Star Bath</th>
                <th>Mini-Groom</th>
                <th>Full Groom</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Luxurious bath with premium shampoo & conditioner</td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
              </tr>
              <tr>
                <td>Gentle ear cleaning & care</td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
              </tr>
              <tr>
                <td>Hand blow-dry & 5-minute massage</td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
              </tr>
              <tr>
                <td>Full body brushing</td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
              </tr>
              <tr>
                <td>Premium cologne & accessories</td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
              </tr>
              <tr>
                <td>Stylish bandana, bow or accessory</td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
              </tr>
              <tr>
                <td>Nail clipping & filing</td>
                <td className="dash">-</td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
              </tr>
              <tr>
                <td>Refreshing oral care</td>
                <td className="dash">-</td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
              </tr>
              <tr>
                <td>Paw pad cleaning & shave</td>
                <td className="dash">-</td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
              </tr>
              <tr>
                <td>Small shear trim (2 areas)</td>
                <td className="dash">-</td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
              </tr>
              <tr>
                <td>Full-body trim or shave</td>
                <td className="dash">-</td>
                <td className="dash">-</td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
              </tr>
              <tr>
                <td>Custom haircut & scissor finishing</td>
                <td className="dash">-</td>
                <td className="dash">-</td>
                <td>
                    {IoMdCheckmarkCircleOutline({ className: "check-icon", size: 20 })}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default ServiceComparison;
